import script from "./PleaseSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./PleaseSelect.vue?vue&type=script&setup=true&lang=js"

import "./PleaseSelect.vue?vue&type=style&index=0&id=4c43289a&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c43289a"]])

export default __exports__